import { BrowserModule } from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import { getLocale } from '@src/lib/util/getLocale';

import { AppRoutingModule } from '@src/app/app-routing.module';
import { AppComponent } from '@src/app/app.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { environment } from '@src/environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {AppUiModule} from '@src/app/ui-components/app-ui.module';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {MatToolbarModule} from '@angular/material/toolbar';
import {EffectsModule} from '@ngrx/effects';
import {FormsModule} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import { GermanDateAdapter } from '@src/app/german-date-adapter';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

import { MatTooltipModule } from '@angular/material/tooltip';


/* lokale Datepipe */
import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/DE';
import {SecurityGuard} from '@src/app/securityGuard';
import {Security} from '@src/app/security';
import {Layout} from '@src/app/layoutSize';
import { AutoGeneratedComponent } from '@src/app/auto-generated/auto-generated.component';
registerLocaleData(localeDE);
/* Ende lokale Datepipe */

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const dev = environment.production ? [] : [StoreDevtoolsModule.instrument({ maxAge: 25 })];

@NgModule({
  declarations: [
    AppComponent,
    AutoGeneratedComponent,

  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        // ngx-translate and the loader module
        HttpClientModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        AppUiModule,
        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),
        ...dev,     // FUNTKIONIERT NICHT, environment schuldig?
        StoreDevtoolsModule.instrument({maxAge: 25, logOnly: environment.production}),
        FormsModule,
        MatSelectModule,


    ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: getLocale(),
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: getLocale(),
    },
    {
      provide: DateAdapter,
      useClass: GermanDateAdapter,
    },
    SecurityGuard,
    Security,
    Layout,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


